import {SystemEntryProperties,SystemEntryCallback,SystemEntryFallback} from "../SystemEntry";


export default {
    name:"SystemFile",
    type:"object",
    props:[
        ...SystemEntryProperties,
        {
            name:"write",
            type:"(text:string,callback:function,fallback:function):Promise<undefined>",
            description:"Overwrites the file content",
            props:[SystemEntryCallback,SystemEntryFallback],
        },
        {
            name:"append",
            type:"(text:string,callback:function,fallback:function):Promise<undefined>",
            description:"Adds content to the end of the file",
            props:[SystemEntryCallback,SystemEntryFallback],
        },
        {
            name:"readAsText",
            type:"(callback:function,fallback:function):Promise<String>",
            description:"Reads the file content as text",
            props:[
                {
                    name:"callback",
                    type:"(content:String):void",
                },
                SystemEntryFallback,
            ],
        },
        {
            name:"readAsDataURL",
            type:"callback:function,fallback:function):Promise<String|null>",
            description:`
                Reads a file as data url. 
                @Use it to read for example image files to get the image content as base64 string
            `,
            props:[
                {
                    name:"callback",
                    type:"(data:string|ArrayBuffer|null):void",
                },
                SystemEntryFallback,
            ],
        },
    ],
}
